import React from "react";

import './Spinner.css';
import propeller from './loading-prop.svg'
import propellerBlack from './loading-prop-black.svg'

export default function Spinner({ displayInline, width, blackProp }) {
    if (displayInline) {
        return (
            <span className='propeller-spinner' style={{ display: 'inline-block' }}>
                <img
                    src={blackProp ? propellerBlack : propeller}
                    style={{
                        width: !!width ? width : null
                    }} />
            </span>
        );
    }

    return (
        <div className='propeller-spinner' style={{
            display: displayInline ? 'inline-block' : null
        }}>
            <img
                src={blackProp ? propellerBlack : propeller}
                style={{
                    width: !!width ? width : null
                }} />
        </div>
    );
}